import { jsx as e } from "../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import r from "../../../../core/Context/useCoreContext.js";
import t from "../../../../images/generic-use-first-touch.svg.js";
import o from "../../../internal/Typography/Typography.js";
import { TypographyElement as l, TypographyVariant as n } from "../../../internal/Typography/types.js";
import { Fragment as m } from "../../../../external/preact/dist/preact.module.js";
import { CapitalHeader as p } from "../../../internal/CapitalHeader/CapitalHeader.js";
const h = ({ hideTitle: a }) => {
  const { i18n: i } = r();
  return /* @__PURE__ */ e(m, { children: [
    /* @__PURE__ */ e(p, { hideTitle: a, titleKey: "capital.needSomeExtraMoney" }),
    /* @__PURE__ */ e("div", { className: "adyen-pe-capital-overview__unqualified-state", children: [
      /* @__PURE__ */ e("div", { className: "adyen-pe-capital-overview__unqualified-state-img", children: /* @__PURE__ */ e("img", { srcSet: t, alt: "" }) }),
      /* @__PURE__ */ e(o, { el: l.PARAGRAPH, variant: n.BODY, large: !0, children: i.get("capital.youWillSoonQualifyForAFinancialOffer") })
    ] })
  ] });
};
export {
  h as default
};
